const allowedPaths = [
  './assets'
];

window.onerror = (message, source, lineno, colno, error) => {
  const stack = error.stack.split('\n');

  if (canReport(stack)) {
    const errorData = {
      message,
      stack,
      url: window.location.href,
      source,
      lineno,
      colno
    };

    $.post('/error-handle', errorData);
  }

  return false;
};

function canReport(stack) {
  let allowedToReport = false;

  for (let i = 0; i < stack.length; i++) {
    if (allowedToReport) {
      break;
    }

    const pathArr = stack[i].split(':///');

    if (pathArr.length > 1) {
      const path = pathArr[1];
      for (let i = 0; i < allowedPaths.length; i++) {
        const allowedPath = allowedPaths[i];

        if (path.indexOf(allowedPath)) {
          allowedToReport = true;
          break;
        }
      }
    }
  }

  return allowedToReport;
}
